// extracted by mini-css-extract-plugin
module.exports = {"phone":"a10a3f92e9--phone--2hdlc","dropdown":"a10a3f92e9--dropdown--Cy7Xh","show":"a10a3f92e9--show--h83Iv"};